var muchBetterParser = function muchBetterParser(phoneNumber) {
  var callingCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '46';
  return phoneNumber.replace(/^\+/, '').replace(/^00/, '').replace(/^0/, callingCode);
};

export default muchBetterParser;